import { render } from "./NewEmployeeEntryRecordEdit.vue?vue&type=template&id=0da35310"
import script from "./NewEmployeeEntryRecordEdit.vue?vue&type=script&lang=js"
export * from "./NewEmployeeEntryRecordEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__